export function OrderInfoController($filter, cartDisplayService, ORDER_TYPES) {
    'ngInject';
    var vm = this;
    vm.cartDisplay = {};
    vm.getEstimationString = getEstimationString;
    vm.getOrderHasEstimate = getOrderHasEstimate;
    vm.getOrderTimePrefixString = getOrderTimePrefixString;
    vm.getOrderTimeString = getOrderTimeString;
    vm.$onInit = activate;

    ///---------------------

    function getOrderHasEstimate() {
        return !!vm.cartDisplay.estimatedFulfillmentMoment;
    }

    function getEstimationString() {
        if(vm.cartDisplay.diningOption == ORDER_TYPES.DELIVERY) return 'Your order should arrive in ';
        if(vm.cartDisplay.diningOption == ORDER_TYPES.TAKE_OUT) return 'Your order should be ready in ';
        return '';
    }

    function _getOrderEstimatedString() {
        if(vm.cartDisplay.diningOption == ORDER_TYPES.DELIVERY) return 'Your order will arrive around ';
        if(vm.cartDisplay.diningOption == ORDER_TYPES.TAKE_OUT) return 'Your order will be ready around ';
        return '';
    }

    function getOrderTimePrefixString() {
        return getOrderHasEstimate()
            ? _getOrderEstimatedString()
            : getEstimationString();
    }

    function getOrderTimeString() {
        return getOrderHasEstimate()
            ? $filter('receiptTime')(vm.cartDisplay.estimatedFulfillmentMoment, vm.cartDisplay.modifiedMoment)
            : $filter('fromNow')(vm.cartDisplay.fulfillmentMoment);
    }

    function activate() {
        cartDisplayService.getDisplayData(vm.previousCart)
            .then(() => vm.cartDisplay = cartDisplayService.displayData);
    }
}
